import type * as React from 'react';
import type { CurrentUserDto } from '../../../../../../types/UserDtos';
import Link from '../../../../components/Link';
import { isFeatureEnabled } from '../../../../services/Features';
import { getCustomLogoPath, SI_LOGO_ICON_ONLY, SI_LOGO_TWO_LINES } from '../../../../services/logo';
import styles from './style.m.less';

type Props = {
    user: CurrentUserDto;
    iconOnly?: boolean;
};

const Logo: React.FC<Props> = ({ user, iconOnly }) => {
    const { companyLogoId, companyLogoCompactId } = user.company.companyDesignSettings;
    const customLogoSrc = companyLogoId && getCustomLogoPath(companyLogoId);
    const customLogoCompactSrc =
        (isFeatureEnabled('FEATURE_navigationCompact') &&
            companyLogoCompactId &&
            getCustomLogoPath(companyLogoCompactId)) ||
        customLogoSrc;

    return (
        <Link
            className={iconOnly ? styles.linkIconOnly : styles.link}
            href="/app/home"
            aria-label="Small Improvements Home"
            eventTracking={{ category: 'navigation header', action: 'click logo' }}
            testId="home-link"
        >
            {iconOnly &&
                (customLogoCompactSrc ? (
                    <img className={styles.logoCustomIconOnly} src={customLogoCompactSrc} alt="" />
                ) : (
                    <img className={styles.logoIconOnly} src={SI_LOGO_ICON_ONLY} alt="" />
                ))}

            {!iconOnly &&
                (customLogoSrc ? (
                    <img className={styles.logoCustom} src={customLogoSrc} alt="" />
                ) : (
                    <img className={styles.logoFull} src={SI_LOGO_TWO_LINES} alt="" />
                ))}
        </Link>
    );
};

export default Logo;
